<template>
  <sfs-form-modal
    :id="modalId"
    title="Edit Item"
    @on-hide="resetFormData"
  >
    <invoice-item-form
      v-bind="value"
      :client_id="value.invoice?.client_id"
      @on-submit="updateItem"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
      :new-form="false"
    />
  </sfs-form-modal>
</template>

<script>
import InvoiceItemForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'InvoiceItemEditModal',
  mixins: [formModalMixin],
  components: {
    InvoiceItemForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalId: `invoice-item-${this.value.id}-edit-modal`,
    };
  },
  methods: {
    updateItem(data, handleUpdate) {
      handleUpdate(this.$invoicesAPI.updateItem(this.value.id, data));
    },
    onSave(invoiceItem) {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save', invoiceItem);
    },
  },
};
</script>
